<template>
    <div class="user-blocked">
        <h1>{{ blockedMessage }}</h1>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "UserBlocked",
    computed: {
        ...mapState("utils", ["translator"]),
        blockedMessage() {
            return (this.translator && this.translator.usuariBloquejat) || "User blocked";
        },
    },
};
</script>

<style scoped>
.user-blocked {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
